import { Injectable, inject } from '@angular/core';
import { RequestOptions } from '../interfaces/callerInterfaces';
import { EMPTY, Observable, of, tap, catchError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseRequestHandlerService {
  private baseUrl: string = environment.apiUrl;
  private authService: AuthService;
  private router: Router;
  private http: HttpClient;

  constructor() {
    this.authService = inject(AuthService); // Only inject once
    this.router = inject(Router);
    this.http = inject(HttpClient);
  }

  private getHeaders(): HttpHeaders {
    let token = this.authService.getToken();
    if (token) {
      return new HttpHeaders({
        Authorization: 'Bearer ' + token,
      });
    } else {
      return new HttpHeaders();
    }
  }

  sendRequest<T>(options: RequestOptions): Observable<T> {
    if (!this.authService.getToken()) {
      this.http
        .request<T>(options.method, this.baseUrl + options.url, {
          body: options.body,
          params: options.prams,
          headers: this.getHeaders(),
        })
        .pipe(
          tap({
            error: (error) => this.errorHandler(error),
          }),
          catchError((error) => {
            // Optionally handle errors here as well
            return EMPTY; // or throwError(error)
          })
        );
    }

    return this.http
      .request<T>(options.method, this.baseUrl + options.url, {
        body: options.body,
        params: options.prams,
        headers: this.getHeaders(),
      })
      .pipe(
        // tap({
        //   error: (error) => this.errorHandler(error),
        // }),
        catchError((error) => {
          // Optionally handle errors here as well
          // return EMPTY; // or throwError(error)
          throw new Error(error);
          // return of(error);
        })
      );
  }

  private errorHandler(error: any) {
    // TODO: Implement proper error handling (e.g., showing a toast notification)
    console.error('An error occurred in errorHandler ', error);
    return EMPTY;
  }
}
